import { styled } from '@mui/styles';

export const CompanyRowStyled = styled('div')(({ theme: { palette, spacing } }: any) => ({
    '& .company': {
        display: 'flex',
        alignItems: 'center',
        flexGrow: 100,
        gap: '15px',
        margin: spacing(0.5, 0),
        '& .order': { flex: 1, minWidth: '25px', color: palette.lightGrey, fontSize: '16px' },
        '& .company-row': {
            display: 'flex',
            flexGrow: 100,
            '& .input': {
                display: 'flex',
                flex: 100,
                alignItems: 'center',
                padding: spacing(0.8, 2.5),
                justifyItems: 'flex-start',
                minHeight: '52px',
                border: `1px solid ${palette.colors.greyInformationLight}`,
                boxSizing: 'border-box',
                fontSize: '14px',
                color: palette.subline,
                '&.left': { flex: 50, borderRadius: '8px 0 0 8px', justifyContent: 'flex-start' },
                '&.right': {
                    flex: 50,
                    borderRadius: '0 8px 8px 0',
                    borderLeft: 'none',
                    '&:hover': {
                        cursor: 'pointer',
                    },
                    '& div:first-of-type': {
                        display: 'flex',
                        flex: 100,
                    },
                    // '& > textarea': { height: undefined },
                },
            },
        },
        '& .action': {
            flex: 1,
            lineHeight: '18p',
            color: palette.colors.greyLighter,
            '&:hover': { cursor: 'pointer' },
        },
    },
}));
